<div class="filter">
  <mat-date-range-input
    class="filter__input"
    [formGroup]="dateRangeGroup"
    [rangePicker]="picker"
    [dateFilter]="dateFilter">
    <input matStartDate formControlName="from" placeholder="Start date" />
    <input matEndDate formControlName="to" placeholder="End date" />
  </mat-date-range-input>
  <mat-date-range-picker #picker>
    <mat-date-range-picker-actions>
      <app-no-date-switch (checkedChange)="noDate($event)"></app-no-date-switch>
      <button class="filter__reset-button" mat-stroked-button (click)="reset()" matDateRangePickerCancel>Reset</button>
      <button mat-flat-button (click)="apply()" matDateRangePickerApply>Apply</button>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
  <div>
    @if (dateRangeGroup.get('from')?.value || dateRangeGroup.get('to')?.value) {
      <span (click)="picker.open()" class="material-symbols-outlined">filter_1</span>
    } @else {
      <span (click)="picker.open()" class="material-symbols-outlined">filter_list</span>
    }
  </div>
</div>
